module.exports = __webpack_public_path__ + "img/student_default_img_boy.8d8cebf5.png";